import { getToken, redirectToLogin, tryRefreshToken } from "../data/auth.service";
import { formatValidationErrors } from "../services/validationErrors";

// Requête authentifiée : sur un 401 (token d'accès expiré), on tente UNE fois de
// rafraîchir le token puis on rejoue la requête. Évite la reconnexion hebdomadaire.
async function authFetch(url, options = {}) {
    const doFetch = () => fetch('/api/' + url, {
        ...options,
        headers: { ...(options.headers || {}), Authorization: 'Bearer ' + getToken() }
    });

    let response = await doFetch();
    if (response.status === 401) {
        const refreshed = await tryRefreshToken();
        if (refreshed) {
            response = await doFetch();
        }
    }
    return response;
}

async function readJsonResponse(response) {
    const text = await response.text();
    if (!text) {
        return null;
    }

    try {
        return JSON.parse(text);
    } catch {
        const contentType = response.headers.get('content-type') || '';
        if (contentType.includes('text/html') || text.trimStart().startsWith('<')) {
            throw new Error(response.status === 413
                ? 'Le fichier est trop volumineux pour être envoyé.'
                : `Le serveur a renvoyé une page HTML au lieu d'une réponse JSON (HTTP ${response.status}).`);
        }

        throw new Error(text);
    }
}

async function throwResponseError(response) {
    const fallback = `Erreur ${response.status}`;
    const text = await response.text();
    if (!text) {
        throw new Error(fallback);
    }

    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('text/html') || text.trimStart().startsWith('<')) {
        throw new Error(response.status === 413
            ? 'Le fichier est trop volumineux pour être envoyé.'
            : fallback);
    }

    try {
        const data = JSON.parse(text);
        throw new Error(data.message || data.Message || formatValidationErrors(data.errors) || data.title || data.detail || fallback);
    } catch (error) {
        if (error instanceof SyntaxError) {
            throw new Error(text);
        }

        throw error;
    }
}

export async function get(url) {
    const response = await authFetch(url);

    if (response.status === 401) {
        redirectToLogin();
    } else if (response.status === 403) {
        throw new Response("", { status: 403 });
    } else if (response.status === 402) {
        window.location.replace('/renouvellement');
    } else if (response.status === 400) {
        return null;
    } else if (response.status === 404) {
        throw new Response("", { status: 404 });
    }
    else if (response.status === 405) {
        return { error: "Votre abonnement actuel ne vous permet pas d'accéder à cette page." };
    }

    const data = await readJsonResponse(response);

    return data;
}

export async function getPublic(url) {
    const response = await fetch('/api/' + url);
    if (response.status === 404) {
        throw new Response("", { status: 404 });
    } else if (response.status === 405) {
        throw new Response("", { status: 405 });
    }
    const data = await readJsonResponse(response);

    return data;
}
export async function post(data, url) {

    const response = await authFetch(url, {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify(data)
    });

    if (response.status === 401) {
        redirectToLogin();
    }
    else if (response.status === 403) {
        throw new Response("", { status: 403 });
    }
    else if (response.status === 404) {
        throw new Response("", { status: 404 });
    }
    else if (response.status === 400) {
        await throwResponseError(response);
    }
    else if (response.status === 405) {
        return { error: "Votre abonnement actuel ne vous permet pas d'accéder à cette page." };
    }
    else if (response.status === 413) {
        await throwResponseError(response);
    }
    else if (response.status === 500) {
        await throwResponseError(response);
    }

    let resp = await readJsonResponse(response);
    return resp;
}
export async function postPublic(data, url) {

    const response = await fetch('/api/' + url, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (response.status === 403) {
        throw new Response("", { status: 403 });
    }
    else if (response.status === 404) {
        throw new Response("", { status: 404 });
    }
    else if (response.status === 400) {
        await throwResponseError(response);
    }
    else if (response.status === 405) {
        throw new Response("", { status: 405 });
    }
    else if (response.status === 500) {
        await throwResponseError(response);
    }
    return await readJsonResponse(response);
}
export async function putPublic(data, url) {

    const response = await fetch('/api/' + url, {
        method: 'PUT',
        headers: {
            'Content-type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    if (response.status === 403) {
        throw new Response("", { status: 403 });
    }
    else if (response.status === 404) {
        throw new Response("", { status: 404 });
    }
    else if (response.status === 400) {
        await throwResponseError(response);
    }
    else if (response.status === 405) {
        throw new Response("", { status: 405 });
    }
    else if (response.status === 500) {
        await throwResponseError(response);
    }
    return await readJsonResponse(response);
}

export async function put(data, url) {
 
    const response = await authFetch(url, {
        method: 'PUT',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify(data)
    });

    if (response.status === 401) {
        redirectToLogin();
    }
    else if (response.status === 403) {
        throw new Response("", { status: 403 });
    }
    else if (response.status === 404) {
        await throwResponseError(response);
    }
    else if (response.status === 400) {
        await throwResponseError(response);
    }
    else if (response.status === 405) {
        throw new Response("", { status: 405 });
    }
    else if (response.status === 500) {
        await throwResponseError(response);
    }
    return await readJsonResponse(response);
}

export async function del(url) {
    const response = await authFetch(url, {
        method: 'DELETE',
        headers: { 'Content-type': 'application/json' }
    });

    if (response.status === 401) {
        redirectToLogin();
    }
    else if (response.status === 403) {
        throw new Response("", { status: 403 });
    }
    else if (response.status === 404) {
        throw new Response("", { status: 404 });
    }
    else if (response.status === 400) {
        await throwResponseError(response);
    }
    else if (response.status === 405) {
        throw new Response("", { status: 405 });
    }
    else if (response.status === 500) {
        await throwResponseError(response);
    }
    const data = await readJsonResponse(response);
    return data;
}
